"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Alert = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Alert"));
var _context = require("../../../services/intl/context");
var _AirportResult = _interopRequireDefault(require("./AirportResult"));
var _getIATALocations = require("../services/getIATALocations");
var _jsxRuntime = require("react/jsx-runtime");
var _FormattedMessage;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const renderLocations = (locations, onSelect) => {
  if (locations.length === 0) {
    return null;
  }
  return locations.map(location => /*#__PURE__*/(0, _jsxRuntime.jsx)(_AirportResult.default, {
    item: location,
    onClick: onSelect
  }, location.locationId));
};
const AirportListData = ({
  value,
  onSelect
}) => {
  const [state, setDataState] = React.useState({
    step: "init"
  });
  const intl = (0, _reactIntl.useIntl)();
  const {
    language
  } = (0, _context.useIntl)();
  React.useEffect(() => {
    (0, _getIATALocations.getIATALocations)(value, language.iso).then(locations => {
      setDataState({
        step: "data",
        data: locations
      });
    }).catch(() => {
      setDataState({
        step: "error"
      });
    });
  }, [value, language.iso]);
  switch (state.step) {
    case "data":
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: renderLocations(state.data, onSelect)
      });
    case "error":
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Alert.default, {
        type: "critical",
        labelClose: intl.formatMessage({
          id: "orbit.button_close"
        }),
        children: _FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "common.api_error"
        }))
      });
    case "init":
      // show nothing until we get the first response
      return null;
    default:
      (_x => {
        throw new Error("IATAPicker: unexpected state was unhandled!");
      })(state);
      return null;
  }
};
var _default = AirportListData;
exports.default = _default;